import { Signal } from "@lit-labs/signals";
import type { CreatorItem, ICreatorSelectState } from "./types";

export class CreatorSelectState implements ICreatorSelectState {
  readonly selectedIds = new Signal.State<Set<string>>(new Set());
  readonly selectedItems = new Signal.State<CreatorItem[]>([]);
}
